import { render, staticRenderFns } from "./LprUnknown.vue?vue&type=template&id=4cb8ad7b&"
import script from "./LprUnknown.vue?vue&type=script&lang=js&"
export * from "./LprUnknown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports